// extracted by mini-css-extract-plugin
export default {"root":"TeamsApp-root","content":"TeamsApp-content","contentContainer":"TeamsApp-contentContainer","fadeIn":"TeamsApp-fadeIn","fadeOut":"TeamsApp-fadeOut"};